// Constants for Board.js's render subtree (Board.js, BoardData.js,
// BoardPodiums.js, PodiumCard.js, BoardTableWrapper.js, BoardTable.js) —
// not module-wide; the home view, modals, and LeaderboardTvHeader.js are
// out of scope. Files in this subtree keep their own local constants when
// they're only coincidentally equal (e.g. BASE_FONT_SIZE); only genuinely
// shared values like TABLE_MARGIN_TOP belong here.

// Board width at/below which a board switches to its unified "narrow" view —
// Board.js's dropdown menu, the podium's small-row tier (BoardPodiums.js), and
// the table's Date/avatar/margin collapse (BoardTable.js) all transition at
// this one shared threshold, so they can't drift apart.
export const NARROW_BREAKPOINT = 820;

// Board width at/below which the Change column/line hides (BoardData.js,
// BoardTable.js) and the podium rows compress to their "minimized" tier
// (BoardPodiums.js) — kept as one shared threshold for the same reason as
// NARROW_BREAKPOINT above.
export const MINIMIZED_BREAKPOINT = 480;

// Board width at which TV Mode scaleFactor === 1 (matches normal-view size)
// when there is one active board; scaling only ever grows things above that threshold
// and only in TV Mode. 1024 also used as threshold above which TV Mode button gets rendered
export const TV_SCALE_ANCHOR_WIDTH = 1024;
// Multiplier used for dynamic calculation of anchor as a function of active board count
// Lower value means anchor shrinks more slowly as board count grows.
export const TV_SCALE_BOARD_COUNT_DAMPING = 0.2;
// Max factor by which elements will grow while in TV mode by as board size increases
export const TV_SCALE_MAX = 1.6;

// Board-header elements (exercise name, info-icon trigger, settings icon) scale
// 1:1 with scaleFactor, same as the podium/table below them. Passed through
// helpers.js's scaleSizes() rather than each getting its own Math.round(...) line.
export const HEADER_SCALED_SIZES = {
  exerciseNameFontSize: 12,
  infoIconWrapperSize: 16,
  infoIconWrapperBorderWidth: 1,
  infoIconSize: 10,
  settingsIconSize: 15,
};

// Scales more conservatively than the rest of TV Mode — full-rate growth
// risks colliding with an adjacent board (up to 3 open side by side) or
// clipping off-screen.
export const TOOLTIP_POPUP_SCALE_CAP = 1.3;
export const TOOLTIP_POPUP_SCALED_SIZES = {
  paddingY: 14,
  paddingX: 16,
  minWidth: 300,
  maxWidth: 420,
};

// TableWrapper's margin-top, in px at scaleFactor === 1. Must stay in sync
// with BoardTableWrapper.js's tableEnd math — see BEHAVIOR.md Invariants for
// why that's kept as two independently-sourced terms, not one shared value.
export const TABLE_MARGIN_TOP = 16;

// API-supplied enum on each leaderboard row (BoardTable.js's Change column,
// PodiumCard.js's Change line) — no "unchanged" value is checked today since
// both usages fall back to a neutral display whenever changeDirection is
// neither of these.
export const CHANGE_DIRECTION_UP = 2;
export const CHANGE_DIRECTION_DOWN = 1;
